(() => {
  function initCatalog(root) {
    if (root.dataset.listInitialized) return;
    root.dataset.listInitialized = 'true';
    const grid = root.querySelector('[data-list-grid]');
    if (!grid) return;
    const cards = [...grid.querySelectorAll('[data-product-card]')];
    const storeCards = cards.filter(card => card.hasAttribute('data-store-product'));
    const storeOrder = new Map(storeCards.map((card, index) => [card, index]));
    const filters = [...root.querySelectorAll('[data-filter]')];
    const empty = grid.querySelector('[data-list-empty]');
    const sort = root.querySelector('[data-list-sort]');
    let active = new URLSearchParams(window.location.search).get('category') || 'all';

    const normalize = value => (value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const isVisibleFor = (card, key) => key === 'all' || normalize(card.dataset.category).includes(normalize(key)) || normalize(card.dataset.tags).includes(normalize(key));

    function render() {
      let visibleCount = 0;
      cards.forEach(card => {
        const visible = isVisibleFor(card, active);
        card.hidden = !visible;
        if (visible) visibleCount++;
      });
      if (empty) empty.style.display = visibleCount ? 'none' : 'block';
      filters.forEach(filter => {
        const key = filter.dataset.filter;
        filter.classList.toggle('active', key === active);
        const count = cards.filter(card => isVisibleFor(card, key)).length;
        const countNode = filter.querySelector('[data-filter-count]');
        if (countNode) countNode.textContent = String(count);
      });
    }

    filters.forEach(filter => filter.addEventListener('click', () => {
      active = filter.dataset.filter || 'all';
      render();
    }));

    if (sort) sort.addEventListener('change', () => {
      if (sort.hasAttribute('data-collection-sort')) {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
        return;
      }
      const mode = sort.value;
      const ordered = [...storeCards].sort((a, b) => {
        if (mode === 'name') return (a.dataset.name || '').localeCompare(b.dataset.name || '');
        if (mode === 'price-low') return Number(a.dataset.price || 0) - Number(b.dataset.price || 0);
        return storeOrder.get(a) - storeOrder.get(b);
      });
      const pagination = grid.querySelector('.list-pagination');
      ordered.forEach(card => grid.insertBefore(card, pagination || empty));
      render();
    });

    render();
  }

  function boot() { document.querySelectorAll('[data-list-catalog]').forEach(initCatalog); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
